
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize Sentry for error monitoring (must run before rendering)
import { initSentry } from './lib/sentry'
initSentry()

import { ErrorBoundary } from './components/ErrorBoundary'
import { HelmetProvider } from 'react-helmet-async';

// Register service worker for push notifications
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
    .then(() => {
      // Service Worker registered silently in production
      if (import.meta.env.DEV) {
        console.log('Service Worker registrado exitosamente');
      }
    })
    .catch(error => {
      console.error('Error al registrar Service Worker:', error);
    });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </ErrorBoundary>
);
